import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";
import { PaginationContextProvider } from "@ds-cps/ui";

import {
  BreadCrumbItem,
  CustomBreadCrumb
} from "@components/BreadCrumb/CustomBreadCrumb";

import { ResourcesContextProvider } from "@resource/components/context/ResourcesContextProvider";

import { ResourcesOverview } from "../components/ResourcesOverview";

export const ResourcesPage: FunctionComponent = () => {
  const { t: tCommon } = useTranslation();
  const { t } = useTranslation(undefined, { keyPrefix: "resources" });

  const breadCrumbs: BreadCrumbItem[] = [
    {
      name: tCommon("home.nav_item.label"),
      url: "/"
    },
    {
      name: tCommon("resources.nav_item.label")
    }
  ];

  return (
    <Page title={t("page_title")}>
      <CustomBreadCrumb breadCrumbs={breadCrumbs} />
      <div className="flex flex-col" data-testid="resources-overview-content">
        <ResourcesContextProvider>
          <PaginationContextProvider>
            <ResourcesOverview />
          </PaginationContextProvider>
        </ResourcesContextProvider>
      </div>
    </Page>
  );
};
